import { AnalysisCommentDTO } from "@models/platform-analysis/entities/steps/feature";
import { ManagedAccountFilterDTO } from "@models/managed-accounts/entities/analysis";
import { ReviewDecisionStatus } from "@models/reviews/entities/status";
import { AnalysisFeePortfolioSetupType } from "@models/platform-analysis/enums/fee/portfolioSetupType";
import { ProductRecommendationDTO } from "@models/platform-analysis/entities/steps/summary";

export class ManagedAccountFeeAnalysisDTO {
  all: ManagedAccountFeeAnalysisContainerDTO =
    new ManagedAccountFeeAnalysisContainerDTO();
  shortlisted: ManagedAccountFeeAnalysisContainerDTO | null = null;
  disqualified: ManagedAccountFeeAnalysisContainerDTO | null = null;
}

export class ManagedAccountFeeAnalysisContainerDTO {
  portfolioSize = 0;
  header = "";
  selectedSubProducts: SelectedSubProductDTO[] = [];
  sections: MAAnalysisSectionDTO[] = [];
  filters: ManagedAccountFilterDTO = new ManagedAccountFilterDTO();
  investmentPlatformCodes?: ManagedAccountInvestmentPlatformCodeDTO[];
}

export class ManagedAccountInvestmentPlatformCodeDTO {
  managerName?: string;
  name?: string;
  platformCodeData?: MAPlatformCodeDTO[];
}

export class MAPlatformCodeDTO {
  subProductId = "";
  platformCode?: string;
  order = 0;
}

export class MAAnalysisBreakdownDTO {
  name = "";
  variableName = "";
  description?: string = "";
  order = 0;
  analysisData?: MAAnalysisDataDTO[];
  breakdowns?: MAAnalysisBreakdownDTO[];
  iconUrl?: string;
  totalFeature?: number;
  isEssential?: boolean;
}

export class MAAnalysisDataDTO {
  subProductId = "";
  productId?: string = "";
  fieldTypeId?: string;
  value?: string;
  valueExcPerf?: string;
  valueInPercent?: string;
  valueExcPerfInPercent?: string;
  isMultiple = false;
  isMissingInvestments = false;
  tooltip: MAAnalysisTooltipDTO | null = new MAAnalysisTooltipDTO();
  secondaryTooltip: MAAnalysisTooltipDTO | null = new MAAnalysisTooltipDTO();
  order = 0;
  isProductMain = false;
  rateCardVersion?: number;
  setupType?: AnalysisFeePortfolioSetupType;
}

export class MAAnalysisSectionDTO {
  variableName = "";
  name = "";
  description?: string;
  iconUrl?: string;
  order = 0;
  analysisData?: MAAnalysisDataDTO[];
  subSections?: MAAnalysisBreakdownDTO[];
  breakdowns?: MAAnalysisBreakdownDTO[];
}

export class MAAnalysisTooltipDataDTO {
  name = "";
  value = "";
  fieldType = "";
}

export class MAAnalysisTooltipDTO {
  header = "";
  additionalText: string | null = "";
  data: MAAnalysisTooltipDataDTO[] = [];
}

export class SelectedInvestmentDTO {
  SHCode = "";
  Weight = 0;
  Value = 0;
}

export class SelectedSubProductDTO {
  id = "";
  name?: string;
  productId = "";
  productName?: string;
  productLogoUrl?: string;
  totalFees = "";
  totalFeesExcPerf = "";
  totalFeesInPercent?: string;
  totalFeesExcPerfInPercent?: string;
  isMissingInvestment = false;
  isMissingAllInvestments = false;
  isComingSoon = false;
  isProductMain = false;
  order = 0;
  decisionStatus?: ReviewDecisionStatus;
  previousDecisionStatus?: ReviewDecisionStatus;
  comment?: AnalysisCommentDTO;
  missingInvestmentsTooltip?: MAAnalysisTooltipDTO;
  setupType: AnalysisFeePortfolioSetupType =
    AnalysisFeePortfolioSetupType.SubProduct;
  rateCardVersion?: number;
  isHidden?: boolean;

  // internal use only
  recommendation?: ProductRecommendationDTO;
}

export type CollapseType = {
  [key in string]?: boolean;
};
